<!-- 创建时间2023/06/20 11:41:55 -->
<!-- 创建人：Zhao bing bing -->
<!-- 组件描述：表单-人脸 -->
<template>
  <div v-if="config">
    <yxt-checkbox
      v-model="config.kngEnabled"
      :true-label="1"
      :false-label="0"
      :disabled="disabled"
      >{{ $t('pc_kng_upload_lbl_switch_faces'/** 开启人脸识别 */) }}
    </yxt-checkbox>
    <yxt-form
      v-if="config.kngEnabled"
      ref="form"
      :model="config"
      :rules="rules"
      class="ml24"
      label-width="auto"
    >
      <yxt-form-item :label="$t('pc_kng_relatedSetting_lbl_face_rule'/** 使用规则 */)" prop="studyBeforeRecognition">
        <yxt-checkbox
          v-model="config.studyBeforeRecognition"
          :disabled="disabled"
          :true-label="1"
          :false-label="0"
          >{{ $t('pc_kng_lbl_learning_before_face'/** 学习前进行人脸识别 */) }}
        </yxt-checkbox>
        <yxt-checkbox
          v-model="config.studyMiddleRecognition"
          :disabled="disabled"
          :true-label="1"
          :false-label="0"
          >{{ $t('pc_kng_lbl_learning_in_face'/** 学习中进行人脸识别（需开启防挂机设置，学员触发防挂机时，需要进行人脸识别） */) }}
        </yxt-checkbox>
      </yxt-form-item>
      <yxt-form-item :label="$t('pc_kng_relatedSetting_lbl_face_type'/** 识别类型 */)" required>
        <yxt-radio-group
          v-model="config.recognitionType"
          direction="row"
          :disabled="disabled"
        >
          <yxt-radio :label="0">{{ $t('pc_kng_lbl_base_img_face_self'/** 基于图片识别是否是本人 */) }}</yxt-radio>
          <yxt-radio :label="1">{{ $t('pc_kng_lbl_base_img_face_self_living'/** 基于图片+活体，识别是否是本人（拦截通过照片作假的场景）*/) }}</yxt-radio>
        </yxt-radio-group>
      </yxt-form-item>
      <yxt-form-item :label="$t('pc_biz_kng_only_app'/** 仅App观看 */)">
        <yxt-checkbox
          v-model="config.appPlay"
          :true-label="1"
          :false-label="0"
          :disabled="disabled"
          >{{ $t('pc_kng_lbl_only_app_play'/** 开启人脸识别的课程/课件，仅支持在App端观看 */) }}
        </yxt-checkbox>
      </yxt-form-item>
    </yxt-form>
  </div>
</template>

<script>
export default {
  name: 'form-face',
  props: {
    config: {
      type: Object,
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const validator = (rule, value, cb) => {
      if (
        !this.config.studyBeforeRecognition &&
        !this.config.studyMiddleRecognition
      ) {
        return cb(new Error(this.$t('pc_kng_lbl_select_face_rule'/** 请选择人脸识别使用规则 */)));
      }
      cb();
    };
    return {
      rules: {
        studyBeforeRecognition: [
          { required: true, validator: validator, trigger: 'change' }
        ]
      }
    };
  },
  watch: {
    'config.kngEnabled'(val) {
      if (val && this.config.recognitionType === undefined) {
        this.$set(this.config, 'recognitionType', 0);
      }
    }
  },
  created() {
    this.config.enabled = 1;
    this.config.useScope = this.disabled ? 0 : 1;
  },
  methods: {
    validate() {
      return new Promise((resolve, reject) => {
        if (this.$refs.form) {
          this.$refs.form.validate(valid => {
            if (valid) {
              resolve();
            } else {
              reject(new Error('fail'));
            }
          });
        } else {
          resolve();
        }
      });
    }
  }
};
</script>